import src from "IMAGE";
export default { src, width: 13, height: 11, blurWidth: 0, blurHeight: 0};
